import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeCompo from '../Components/Home.vue'
import AboutCompo from '../Components/About.vue'
import PanjabiCompo from '../Components/Panjabi.vue'
import ShirtCompo from '../Components/Shirt.vue'
import PantCompo from '../Components/Pant.vue'
import ContractCompo from '../Components/contract.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeCompo,
    meta:{
      title: 'I BRAND BD'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutCompo,
    meta:{
      title: 'I BRAND BD | About'
    }
  },
  {
    path: '/panjabi-collection',
    name: 'panjabi',
    component: PanjabiCompo,
    meta:{
      title: 'I BRAND BD | Panjabi-Collection'
    }
  },
  {
    path: '/shirt-collection',
    name: 'shirt',
    component: ShirtCompo,
    meta:{
      title: 'I BRAND BD | Shirt-Collection'
    }
  },
  {
    path: '/pant-collection',
    name: 'pant',
    component: PantCompo,
    meta:{
      title: 'I BRAND BD | Pant-Collection'
    }
  },
  {
    path: '/contract',
    name: 'contract',
    component: ContractCompo,
    meta:{
      title: 'I BRAND BD | Contract'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next)=>{
  document.title = to.meta.title;
  next();
})

export default router
